/*
 * Free gift opt-in.
 *
 * An unchecked checkbox submits nothing, so the property is carried by a
 * separate hidden input and the checkbox just enables or disables it. Disabled
 * inputs are left out of FormData, which means an unticked box adds no
 * property at all rather than a "No" that would clutter the order.
 */
(function () {
  function bind(wrapper) {
    if (wrapper.dataset.nhGiftReady === 'true') return;
    wrapper.dataset.nhGiftReady = 'true';

    const toggle = wrapper.querySelector('[data-nh-gift-toggle]');
    const prop = wrapper.querySelector('[data-nh-gift-prop]');
    if (!toggle || !prop) return;

    const sync = () => {
      prop.disabled = !toggle.checked;
      wrapper.classList.toggle('nh-gift-optin--on', toggle.checked);
    };

    toggle.addEventListener('change', sync);
    sync();

    // Quick view. The media sits outside the label so opening it cannot
    // toggle the box; accepting from inside the dialog ticks it explicitly.
    const modal = wrapper.querySelector('[data-nh-gift-modal]');
    const opener = wrapper.querySelector('[data-nh-gift-open]');
    if (!modal || !opener || typeof modal.showModal !== 'function') return;

    opener.addEventListener('click', () => modal.showModal());

    const close = () => modal.close();
    wrapper.querySelectorAll('[data-nh-gift-close]').forEach((b) => b.addEventListener('click', close));

    const accept = wrapper.querySelector('[data-nh-gift-accept]');
    if (accept) {
      accept.addEventListener('click', () => {
        toggle.checked = true;
        sync();
        close();
      });
    }

    // Click the backdrop to dismiss.
    modal.addEventListener('click', (event) => {
      if (event.target === modal) close();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-nh-gift-optin]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
